export default __webpack_public_path__ + "images/5524cb85a20c8450e01ea252cdd06a61.png";